<style lang="scss">
.page-wrap-inner {
  padding-top: 0 !important;
}
.no-user-events {
  margin: 0 auto;
  text-align: center;
  margin-top: 100px;
}
.no-user-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-user-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-user-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
</style>
<template>
  <div id="allevent">
    <header class="sticky-top all-event-header py-3 d-none">
      <div class="container-fluid">
        <div
          class="event-list-top-pannel-wrapper d-flex align-items-center justify-content-between"
        >
          <span style="width: 33.33%"></span>

          <span style="width: 33.33%; text-align: right">
            <v-btn
              @click="goToMainLobby()"
              v-if="
                $store.state.DefaultLoginLandingPage == 'enableMainLobby' &&
                $vuetify.breakpoint.smAndUp
              "
              :loading="mainLobbyLoader"
              color="success"
              >Main Lobby</v-btn
            >
            <a
              href="#"
              class="btn btn-black text-uppercase"
              v-show="ShowCreateEventButton == 'true'"
              >Create event</a
            >
            <a
              class="btn btn-black"
              v-show="ShowRegisterEventButton == 'true'"
              value="Register Now"
              data-tag="signUP"
              @click.prevent="goForRegister"
            >
              Event Hub</a
            >
          </span>
        </div>
      </div>
    </header>

    <div class="all-event-wrapper pb-4 mb-5">
      <v-row
        style="
          z-index: 5;
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          opacity: 1;
        "
        align="center"
        justify="center"
        v-if="loaderFlg"
      >
        <v-progress-circular
          size="80"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-row>
      <div
        class="container-fluid px-lg-0"
        @click="onClickHandler"
        data-tag="alleventSec"
      >
        <div class="px-lg-12">
          <div class="row align-items-center">
            <div
              class="col-md-12 col-lg-4 mob-py-0 text-md-center text-lg-left"
            >
              <span>
                <h2 class="my-0" style="color: white">
                  {{ $t("eventlist.selectAnEvent") }}
                </h2>
              </span>
              <h6
                class="session-time-zone mt-md-0"
                style="
                  color: #8b8b8b;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
              >
                {{ localTimeZone }}
              </h6>
            </div>
            <!-----tab area----->
            <div class="col-md-12 col-lg-8 mob-py-0">
              <div class="d-flex justify-content-between align-items-center">
                <div class="event-tab-area">
                  <ul
                    class="nav nav-tabs justify-content-center"
                    id="myTab"
                    role="tablist"
                  >
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        data-toggle="tab"
                        href="javascript: void(0);"
                        id="aLivetab"
                        @click.prevent="setTabflag(1)"
                        role="tab"
                        aria-controls="tab-1"
                        aria-selected="true"
                        v-show="liveflag > 0"
                        >Live & Upcoming
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="javascript: void(0);"
                        @click.prevent="setTabflag(2)"
                        role="tab"
                        id="aunderreviewtab"
                        aria-controls="tab-2"
                        aria-selected="false"
                        v-show="UnderReviewFlag > 0"
                        >Under Review</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="javascript: void(0);"
                        id="aEndedtab"
                        @click.prevent="setTabflag(0)"
                        role="tab"
                        aria-controls="tab-3"
                        aria-selected="false"
                        v-show="Pastflag > 0"
                        >Past</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="javascript: void(0);"
                        id="aAlltab"
                        @click.prevent="setTabflag(3)"
                        role="tab"
                        aria-controls="tab-1-4"
                        aria-selected="false"
                      >
                        {{ $t("eventlist.options") }}</a
                      >
                    </li>
                  </ul>
                </div>

                <div
                  class="right-side-acc text-right d-flex align-items-center justify-content-end"
                >
                  <div
                    class="Sort-area mr-2 mr-md-4"
                    id="spnSortLink"
                    @click.prevent="sortEvent"
                  >
                    Sort
                    <img src="../assets/Images/sort-ico.png" class="ml-2" />
                  </div>
                  <!---my profile start---->
                  <div
                    class="topHeader-Right d-flex1 align-items-center d-none"
                  >
                    <!---->
                    <div class="banner-toppart">
                      <div class="dropdown my-profile pr-0">
                        <span class="circle" v-if="Userlists.userImage !== ''">
                          <img
                            v-bind:src="getCDNUrl(Userlists.userImage)"
                            v-bind:alt="Userlists.userName"
                          />
                        </span>
                        <span
                          class="circle"
                          style="text-transform: uppercase"
                          v-else
                        >
                          {{ getInitials() }}
                        </span>
                        <!-- <span class="circle">TC</span -->
                        <button class="dropbtn">
                          {{ Userlists.userName }}
                        </button>
                        <div id="divdrop" class="dropdown-content">
                          <!-- <router-link to="/myprofile">{{
                    $t("menu.myProfile")
                  }}</router-link> -->

                          <!-- <a
                          id="AdminConsolelnk"
                          href="https://onaircms.e2m.live/"
                          target="blank"
                          >{{ $t("menu.adminConsole") }}</a
                        > -->
                          <router-link
                            v-if="EnableSelfService && hasEventAdminRole()"
                            to="/eventoverview#ManageMyEvents"
                            >Manage My Events</router-link
                          >
                          <a href="#" @click.prevent="clearstate">{{
                            $t("menu.logout")
                          }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---my profile end---->
                </div>
              </div>
            </div>
            <!-----tab area----->
            <!-- <div class="col-md-2 col-lg-3">
              
            </div> -->
          </div>
        </div>
        <div class="tab-content px-md-12 mb-8" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="tab-1"
          >
            <!-----------tab content---->
            <div v-show="eventCount > 0" id="EventList" class="row">
              <!----reapeat box start----->
              <div class="no-user-events" v-if="eventCount == 0">
                <h3>There are currently no events.</h3>
                <h5>Would you like to setup, and host your own event?</h5>
                <a href="https://e2m.live/" target="_blank"
                  >Host Your Own Event</a
                >
              </div>
              <div
                v-for="event in EventsData"
                v-bind:key="event.id"
                data-tag="eventLink"
                class="col-lg-4 col-md-6"
              >
                <div
                  class="wrapperd-flex flex-column custom-nav-tab"
                  v-show="
                    fliterflag == 1 &&
                    (event.status == 'live' || event.status == 'upcoming')
                  "
                  v-on:click="
                    selectEvent(
                      event.id,
                      event.IsPublished,
                      event.clientID,
                      event.eventDefaultSessionPage
                    )
                  "
                >
                  <figure>
                    <img v-bind:src="event.EventLogo" v-bind:alt="event.Name" />
                  </figure>
                  <div class="content px-3 mt-0">
                    <p style="cursor: pointer">{{ event.Name }}</p>
                  </div>

                  <div class="event-date-hld m-3 mt-2 ml-0">
                    <AddEventToCalendar
                      :addToCalendarLabel="event.EventDateStringLabel"
                      :displayLabel="true"
                      :eventTitle="event.Name"
                      :eventStartTimestamp="event.EventStartTimestamp"
                      :eventEndTimestamp="event.EventEndTimestamp"
                    />
                  </div>
                  <!-- <div
                    v-if="event.EventNewStartTime != event.EventNewEndTime"
                    class="event-date-hld m-3"
                  >
                    {{ event.EventNewStartTime }} -
                    {{ event.EventNewEndTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div>
                  <div v-else class="event-date-hld mx-3 pb-3">
                    {{ event.EventNewStartTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div> -->
                </div>

                <div
                  class="wrapperd-flex flex-column"
                  v-show="fliterflag == 0 && event.status == 'ended'"
                  v-on:click="
                    selectEvent(
                      event.id,
                      event.IsPublished,
                      event.clientID,
                      event.eventDefaultSessionPage
                    )
                  "
                >
                  <figure>
                    <img v-bind:src="event.EventLogo" v-bind:alt="event.Name" />
                  </figure>
                  <div class="content px-3 mt-0">
                    <p>{{ event.Name }}</p>
                  </div>
                  <div class="event-date-hld m-3 mt-2">
                    {{ event.EventDateStringLabel }}
                  </div>
                </div>

                <div
                  class="wrapperd-flex flex-column"
                  v-show="fliterflag == 2 && event.status == 'underreview'"
                  v-on:click="
                    selectEvent(
                      event.id,
                      event.IsPublished,
                      event.clientID,
                      event.eventDefaultSessionPage
                    )
                  "
                >
                  <figure style="cursor: pointer; min-height: 80px !important">
                    <img
                      style="border-radius: 8px 8px 0 0"
                      v-bind:src="event.EventLogo"
                      v-bind:alt="event.Name"
                    />
                  </figure>
                  <div class="content px-3 mt-0">
                    <p>{{ event.Name }}</p>
                  </div>

                  <div class="event-date-hld m-3 mt-2 ml-0">
                    <AddEventToCalendar
                      :addToCalendarLabel="event.EventDateStringLabel"
                      :displayLabel="true"
                      :eventTitle="event.Name"
                      :eventStartTimestamp="event.EventStartTimestamp"
                      :eventEndTimestamp="event.EventEndTimestamp"
                    />
                  </div>
                  <!-- <div
                    v-if="event.EventNewStartTime != event.EventNewEndTime"
                    class="event-date-hld m-3"
                  >
                    {{ event.EventNewStartTime }} -
                    {{ event.EventNewEndTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div>
                  <div v-else class="event-date-hld m-3">
                    {{ event.EventNewStartTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div> -->
                </div>

                <div
                  class="wrapperd-flex flex-column"
                  v-show="fliterflag == 3"
                  v-on:click="
                    selectEvent(
                      event.id,
                      event.IsPublished,
                      event.clientID,
                      event.eventDefaultSessionPage
                    )
                  "
                >
                  <figure style="cursor: pointer; min-height: 80px !important">
                    <img
                      style="border-radius: 8px 8px 0 0"
                      v-bind:src="event.EventLogo"
                      v-bind:alt="event.Name"
                    />
                  </figure>
                  <div class="content px-3 mt-0">
                    <p>{{ event.Name }}</p>
                  </div>
                  <div class="event-date-hld m-3 mt-2 ml-0">
                    <AddEventToCalendar
                      :addToCalendarLabel="event.EventDateStringLabel"
                      :displayLabel="true"
                      :eventTitle="event.Name"
                      :eventStartTimestamp="event.EventStartTimestamp"
                      :eventEndTimestamp="event.EventEndTimestamp"
                    />
                  </div>
                  <!-- <div
                    v-if="event.EventNewStartTime != event.EventNewEndTime"
                    class="event-date-hld m-3"
                  >
                    {{ event.EventNewStartTime }} -
                    {{ event.EventNewEndTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div>
                  <div v-else class="event-date-hld m-3">
                    {{ event.EventNewStartTime }}
                    {{ "(" + event.EventTimezone + ")" }}
                  </div> -->
                </div>
              </div>
              <!----reapeat box end----->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
  </div>
</template>
<script>
import db from "../components/firebaseInit";
import common from "@/common";
import firebase from "firebase";
import axios from "axios";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
import moment from "moment-timezone";
import eventsubscribe from "@/components/EventSubscribe";
import AddEventToCalendar from "@/components/AddToCalendar.vue";
import APIs from "@/components/APIInit";
import jwt_decode from "jwt-decode";
import { bus } from "@/main";

let $ = jQuery;
//let lastVisible = null;
let hasMore = true;

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Sessions",
  "/session_cal": "session_cal",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

var vm;

export default {
  components: {
    AddEventToCalendar,
  },
  data() {
    return {
      mainLobbyLoader: false,
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 1,
      //lastVisible: null,
      arrEvents: [],
      EventsData: [],
      searchtext: "",
      IsShowNoDataFound: false,
      IsShowCancelButton: false,
      IsSearchMode: false,
      clientID:
        this.$store.getters.getClient[0] != undefined
          ? this.$store.getters.getClient[0].id
          : "",
      eventCount: 0,
      sortOrder: "desc",
      fliterflag: 1,
      eventListingflag: 1,
      APIs: APIs,
      ShowCreateEventButton: false,
      ShowRegisterEventButton: true,
      liveflag: 0,
      UnderReviewFlag: 0,
      Pastflag: 0,
      tabclickflag: false,
      loaderFlg: false,
      EnableSelfService: false,
      localTimeZone: "",
    };
  },
  methods: {
    getInitials() {
      return common.getInitials(this.$store.state.user[0].name);
    },
    refreshTokenBeforeEventCall() {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              vm.loadingEventpage();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
        // else {
        //   vm.showSnackbar(vm.$t("login.eventnotpublished"), "info", "top");
        //   vm.clearstate();
        // }
      });
    },
    refreshToken(token) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then(function (res) {
          res.user
            .getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              vm.$store.commit("addToken", idToken);
              vm.$store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
            })
            .catch((err) => {
              console.log("err=====", err);
            });
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    goToMainLobby() {
      this.mainLobbyLoader = true;
      this.$router.push("/mainlobby");
    },
    getGeneralSettings() {
      const obj = JSON.parse(window.localStorage["my-app"]);
      if (obj.client[0].id != "") {
        var docRefGeneralSettings = db
          .collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(obj.client[0].id);
        docRefGeneralSettings.get().then(function (doc) {
          if (doc.exists) {
            if (doc.data().ShowCreateEventButton) {
              vm.ShowCreateEventButton = doc.data().ShowCreateEventButton;
            }
          }
        });
      }
    },
    getMeetingSettings: function () {
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(vm.APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          var res = response.data;
          var MObj = new Object();
          MObj.Slot = res.data.Slots;
          MObj.StartDate1 = res.data.StartDate;
          MObj.EndDate1 = res.data.EndDate;
          //MObj.StartDate = moment(res.data.MeetingStartTimestampUTC / 1000);
          //MObj.EndDate = new Date(res.data.MeetingEndTimestampUTC / 1000);
          MObj.StartDate = {
            _seconds: res.data.MeetingStartTimestampUTC / 1000,
            _nanoseconds: 0,
          };
          MObj.EndDate = {
            _seconds: res.data.MeetingEndTimestampUTC / 1000,
            _nanoseconds: 0,
          };
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            MObj.Items = res.data.Items;
          }
          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY");
      return date;
    },
    displayEvents() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      vm.EventsData = [];
      var events = obj.MappedEvent;
      events = events.reduce(function (item, e1) {
        var matches = item.filter(function (e2) {
          return e1.EventId == e2.EventId;
        });
        if (matches.length == 0) {
          item.push(e1);
        }
        return item;
      }, []);
      if (vm.sortOrder == "desc") {
        events = events.sort(function compare(a, b) {
          var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
          var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
          return dateB - dateA;
        });
      } else {
        events = events.sort(function compare(a, b) {
          var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
          var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
          return dateA - dateB;
        });
      }
      var currentTime = parseInt(new Date().getTime() / 1000);

      for (var i = 0; i < events.length; i++) {
        var dtstrt = parseInt(
          new Date(events[i].EventStartDateTime).getTime() / 1000
        );
        var dtEnd = parseInt(
          new Date(events[i].EventEndDateTime).getTime() / 1000
        );
        if (dtstrt > currentTime) {
          events[i].status = "upcoming";
          vm.liveflag++;
        } else if (dtstrt <= currentTime && dtEnd >= currentTime) {
          if (!events[i].IsPublished) {
            events[i].status = "underreview";
            vm.UnderReviewFlag++;
          } else {
            events[i].status = "live";
            vm.liveflag++;
          }
        } else {
          events[i].status = "ended";
          vm.Pastflag++;
        }

        let startTime = events[i].EventStartDateTime.substring(11, 16);
        let endTime = events[i].EventEndDateTime.substring(11, 16);

        var eventNewStartTime = vm.SetTimeByZone(
          moment(events[i].EventStartDate, ["DD-MM-YYYY"]).format(
            "MMM DD, YYYY"
          ),
          moment.tz.guess()
        );
        var eventNewEndTime = vm.SetTimeByZone(
          moment(events[i].EventEndDate, ["DD-MM-YYYY"]).format("MMM DD, YYYY"),
          moment.tz.guess()
        );
        var eventDateStringLabel =
          eventNewStartTime != eventNewEndTime
            ? eventNewStartTime + " to " + eventNewEndTime
            : eventNewStartTime;
        vm.EventsData.push({
          id: events[i].EventId,
          Name: events[i].EventFullName,
          EventLogo: vm.getCDNUrl(events[i].EventLogo),
          EventStartDate: events[i].EventStartDate,
          EventEndDate: events[i].EventEndDate,
          EventStartTimestamp: events[i].EventStartDateTimestamp,
          EventEndTimestamp: events[i].EventEndtDateTimestamp,
          EventDateStringLabel: eventDateStringLabel,
          EventCollectionName: events[i].EventCollectionName,
          EventTypeId: events[i].EventTypeId,
          EventTimezone: moment.tz.guess(), // data.TimeZone,
          EventNewStartTime: vm.SetTimeByZone(
            moment(events[i].EventStartDate, ["DD-MM-YYYY"]).format(
              "MMM DD, YYYY"
            ),
            moment.tz.guess()
          ),
          EventStartDateString:
            moment(events[i].EventStartDate, ["DD-MM-YYYY"]).format(
              "MMM DD, YYYY"
            ) +
            " " +
            startTime, //vm.formatDate(data.EventStartDate),
          EventEndDateString:
            moment(events[i].EventEndDate, ["DD-MM-YYYY"]).format(
              "MMM DD, YYYY"
            ) +
            " " +
            endTime,

          EventNewEndTime: vm.SetTimeByZone(
            moment(events[i].EventEndDate, ["DD-MM-YYYY"]).format(
              "MMM DD, YYYY"
            ),
            moment.tz.guess()
          ),
          IsPublished: events[i].IsPublished,
          StatusClass: events[i].IsPublished ? "" : "event-unpublished",
          status: events[i].status,
          clientID: events[i].ClientId,
          eventDefaultSessionPage: events[i].DefaultSessionPath
            ? events[i].DefaultSessionPath
            : "",
          DefaultLanguage:
            events[i].DefaultLanguage === undefined
              ? "English"
              : events[i].DefaultLanguage,
        });
      }
      vm.hideLoader();
      if (vm.tabclickflag != true) {
        if (vm.liveflag <= 0) {
          vm.fliterflag = 2;
          $("#aEndedtab").removeClass("active");
          $("#aLivetab").removeClass("active");
          $("#aunderreviewtab").addClass("active");
          $("#aAlltab").removeClass("active");
          if (vm.UnderReviewFlag <= 0 && vm.liveflag <= 0) {
            vm.fliterflag = 0;
            $("#aEndedtab").addClass("active");
            $("#aLivetab").removeClass("active");
            $("#aunderreviewtab").removeClass("active");
            $("#aAlltab").removeClass("active");

            if (
              vm.Pastflag <= 0 &&
              vm.UnderReviewFlag <= 0 &&
              vm.liveflag <= 0
            ) {
              vm.fliterflag = 3;
              $("#aEndedtab").removeClass("active");
              $("#aLivetab").removeClass("active");
              $("#aunderreviewtab").removeClass("active");
              $("#aAlltab").addClass("active");
            }
          }
        }
      }

      vm.tabclickflag = false;
      vm.eventCount = vm.EventsData.length;
      if (vm.EventsData.length > 0) {
        if (vm.fliterflag == 1) {
          vm.EventsData = vm.EventsData.filter(function (e) {
            return e.status == "live" || e.status == "upcoming";
          });
        } else if (vm.fliterflag == 2) {
          vm.EventsData = vm.EventsData.filter(function (e) {
            return e.status == "underreview";
          });
        } else if (vm.fliterflag == 0) {
          vm.EventsData = vm.EventsData.filter(function (e) {
            return e.status == "ended";
          });
        } else {
          vm.EventsData = vm.EventsData.filter(function (e) {
            return e.status.Contains(
              "live",
              "upcoming",
              "underreview",
              "ended"
            );
          });
        }
      }
      store.commit("addEventCount", vm.eventCount);

      if (vm.sortOrder == "desc") {
        vm.EventsData = vm.EventsData.sort(function compare(a, b) {
          //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
          var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
          var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
          return dateB - dateA;
        });
      } else {
        vm.EventsData = vm.EventsData.sort(function compare(a, b) {
          //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
          var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
          var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
          return dateA - dateB;
        });
      }

      if (vm.eventCount == 1) {
        //alert(vm.$t("eventlist.routeMessageOnSingleEvent"));
        vm.showSnackbar(
          vm.$t("eventlist.routeMessageOnSingleEvent"),
          "info",
          "top"
        );
        //vm.$router.push(eventDoc[1].DefaultLandingURL);
        //vm.goToEvent(eventDoc, eventDoc.DefaultSessionPath);
        //vm.goToEvent(eventDoc, eventDoc.DefaultSessionPath);
        vm.selectEvent(
          vm.EventsData[0].id,
          vm.EventsData[0].IsPublished,
          vm.EventsData[0].clientID,
          vm.EventsData[0].eventDefaultSessionPage
        );
      }
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    GetEvents() {
      if (!hasMore) {
        return;
      }
    },
    scroll: function () {
      window.onscroll = () => {
        if (hasMore) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            vm.refreshEventList();
          }
        }
      };
    },
    selectEvent: function (
      eventId,
      isPublished,
      clientID,
      eventDefaultSessionPage = ""
    ) {
      console.log(isPublished);
      vm.showLoader();
      db.collection("OA_UAT/ClientList/Clients")
        .doc(clientID)
        .collection("Events")
        .doc(eventId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            vm.goToEvent(doc, eventDefaultSessionPage);
          }
        })
        .catch((error) => {
          vm.hideLoader();
          console.log(error);
        });
    },
    goToEvent: async function (eventDoc, eventDefaultSessionPage) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var eventData = eventDoc.data();
      this.$store.state.historyEvent = eventData;
      this.$store.state.locale = eventData.DefaultLanguage;
      store.commit("addEventID", eventDoc.id);
      store.commit("setEventDefaultSessionPage", eventDefaultSessionPage);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      store.commit("Lobbyloaded", false);
      store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });
      /*++++++++ Font style EventCustomCSS.json JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

      var brandingData;
      try {
        brandingData = await vm.getBrandingJSONDetails(
          eventData.EventCollectionName +
            "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data && brandingData.data.customClientFont) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        } else {
          store.commit("AddEventFont", {
            FontPath: "",
            FontFamily: "",
          });
        }
      } catch (e) {
        store.commit("AddEventFont", {
          FontPath: "",
          FontFamily: "",
        });
        console.log("Error in Branding Json Fetch--", e);
      }
      try {
        brandingData = await vm.getBrandingJSONDetails(
          eventData.EventCollectionName + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          this.item = brandingData.data;
          var bannerDymension = "2048x88";
          var EventBgDymension = "2732x2048";
          var logoDymension = "960x192";
          store.commit("addEventBranding", {
            eventBGImage: vm.getCDNUrl(
              brandingData.data.eventBGImage[EventBgDymension]
            ),
            eventLogo: vm.getCDNUrl(brandingData.data.eventLogo[logoDymension]),
            topBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["topBar"]
              : brandingData.data.headerColorsHexCode["topBar"],
            headerBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["headerBar"]
              : brandingData.data.headerColorsHexCode["headerBar"],
            fontBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["fontBar"]
              : brandingData.data.headerColorsHexCode["fontBar"],
            banner: vm.getCDNUrl(brandingData.data.banner[bannerDymension]),
            mobileBanner: vm.getCDNUrl(brandingData.data.banner["750x103"]),
            shareBanner: vm.getCDNUrl(
              brandingData.data.EventInfo.EventBannerShare
                ? brandingData.data.EventInfo.EventBannerShare
                : ""
            ),
            themeName: brandingData.data["appColorHexCodeType"],
          });
          if (obj !== undefined) {
            if (obj !== null) {
              if (obj.EventBranding[0] !== undefined) {
                $("#imgBanner").attr(
                  "src",
                  vm.getCDNUrl(obj.EventBranding[0].banner)
                );
              }
            }
          }
          $("#btnLoadMenu").click();
          vm.getMeetingSettings();
          vm.getAdvExpoStatus();
          vm.getDynamicFont();
          vm.SubscribeForWebPush();
          let landingURL = "Lobby";
          if (
            eventData.DefaultLandingURL &&
            landingURLOptions[eventData.DefaultLandingURL] &&
            landingURLOptions[eventData.DefaultLandingURL] != ""
          ) {
            landingURL = landingURLOptions[eventData.DefaultLandingURL];
            store.commit("setDefaultLandingPageInsideEvent", landingURL);
          }

          if (landingURL === "ExhibitorsHall") {
            vm.onExpoSelection();
            store.commit("setAdvExpo", true);
          }

          analytics.AddUserLogin(
            eventData.EventCollectionName,
            eventData.EventFullName,
            location.pathname,
            "click",
            "action",
            obj.loginType,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email,
            obj.ClientIP
          );
          if (
            this.$store.state.eventDefaultSessionPage &&
            landingURL != "Lobby"
          ) {
            landingURL =
              landingURLOptions[this.$store.state.eventDefaultSessionPage];
          }
          this.postLeaderboardAction("EVAC");
          this.showzendeskChat();
          debugger;
          if (brandingData.data.EventBannerRedirect) {
            store.commit(
              "AddEventBannerRedirect",
              brandingData.data.EventBannerRedirect
            );
          } else if (brandingData.data.EventInfo.EventBannerRedirect) {
            store.commit(
              "AddEventBannerRedirect",
              brandingData.data.EventInfo.EventBannerRedirect
            );
          }
          router.push({
            name: landingURL,
            params: {
              sid: eventData.EventId,
              eCol: eventData.EventCollectionName,
              ename: eventData.EventFullName,
              estartdt: eventData.EventStartDate,
              eenddt: eventData.EventEndDate,
              tzone: eventData.TimeZone,
            },
          });
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }
    },
    showzendeskChat() {
      if (document.getElementById("launcher")) {
        document.getElementById("launcher").style.display = "none";
        if (this.IsSelfServiceEnabled() && this.isEventAdmin()) {
          document.getElementById("launcher").style.display = "block";
        }
      }
      if (
        !document.getElementById("launcher") &&
        this.IsSelfServiceEnabled() &&
        this.isEventAdmin()
      ) {
        let zendeskchatScript = document.createElement("script");
        zendeskchatScript.setAttribute("id", "ze-snippet");
        zendeskchatScript.setAttribute(
          "src",
          "https://static.zdassets.com/ekr/snippet.js?key=beab9296-5568-4170-a332-0825a99a8442"
        );
        document.body.appendChild(zendeskchatScript);
      }
    },
    refreshEventList: function () {
      //const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };

      axios
        .get(vm.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status == 0 && response.data.result.length > 0) {
            var result = response.data.result;
            var events = [];
            var i;
            var j;
            for (i = 0; i < result.length; ++i) {
              for (j = 0; j < result[i].events.length; j++) {
                events.push(result[i].events[j]);
                //store.commit("setMappedEvent", result[i].events[j]);
              }
            }

            store.commit("setMappedEvent", events);
            store.commit("addEventCount", events.length);
            if (response.data.profile && response.data.profile.AdminRoles) {
              store.commit("setAdminRoles", response.data.profile.AdminRoles);
            }
            vm.displayEvents();
            vm.refreshToken(response.data.customToken);
          }
          // else {
          //   vm.showSnackbar(vm.$t("login.eventnotpublished"), "info", "top");
          //   vm.clearstate();
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatDate: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          dt.getMinutes();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    Returndatetimeformat: function (seconds) {
      var dtt = "";
      dtt = new Date(seconds * 1000);
      var hours = dtt.getHours();
      var minutes =
        dtt.getMinutes().toString() == "0" ? "00" : dtt.getMinutes();
      var newformat = hours >= 12 ? "PM" : "AM";
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + newformat;
      return formattedtime;
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      this.AddAnalitics(event, "click");
    },
    clearstate: function () {
      if (this.$store.state.isSSO) {
        document.cookie = "AT=;domain=.edulife.sg;";
        this.$store.commit("addIsSSO", false);
        location.href = "https://edulife.sg/home?logout";
      }
      store.commit("ClearState", this);
      document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
      document.cookie = "staysigned=";
      document.cookie = "userrole=";
      document.cookie = "userid=";

      firebase
        .auth()
        .signOut()
        .then(
          function () {
            console.log("Signed Out");
          },
          function (error) {
            console.error("Sign Out Error", error);
          }
        );
      location.href = "/";
    },
    sortEvent: function () {
      vm.EventsData = [];
      if (vm.sortOrder === "asc") {
        vm.sortOrder = "desc";
      } else {
        vm.sortOrder = "asc";
      }
      hasMore = true;
      vm.refreshEventList();
    },
    setTabflag: function (val) {
      vm.tabclickflag = true;
      vm.showLoader();
      if (val == 0) {
        $("#aEndedtab").addClass("active");
        $("#aLivetab").removeClass("active");
        $("#aunderreviewtab").removeClass("active");
        $("#aAlltab").removeClass("active");
      } else if (val == 1) {
        $("#aLivetab").addClass("active");
        $("#aEndedtab").removeClass("active");
        $("#aunderreviewtab").removeClass("active");
        $("#aAlltab").removeClass("active");
      } else if (val == 2) {
        $("#aunderreviewtab").addClass("active");
        $("#aEndedtab").removeClass("active");
        $("#aLivetab").removeClass("active");
        $("#aAlltab").removeClass("active");
      } else {
        $("#aAlltab").addClass("active");
        $("#aunderreviewtab").removeClass("active");
        $("#aEndedtab").removeClass("active");
        $("#aLivetab").removeClass("active");
      }
      vm.fliterflag = val;
      hasMore = true;
      vm.refreshEventList();
    },

    loadingEventpage: function () {
      $("#btnAddUserView").click();
      $("#btnPlugins").click();

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      $(document).attr(
        "title",
        this.$t("eventlist.options") + "-" + obj.client[0].name
      );
      $("#allevent").css("background-size", "cover");
      $("#allevent").css("background-color", "none");

      $("#imgBanner").attr("src", vm.getCDNUrl(obj.branding[0].banner));

      $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);
      //-------------------------------------------------------------------------------
      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = vm.getCDNUrl(obj.branding[0].favicon);
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      // $("#topmenu").hide();
      // $("#leftmenu").hide();
      this.EventsData = [];
      vm.refreshEventList();
    },
    getDynamicFont: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
    },

    setOtherParams: function (
      eventid,
      eventCollectionname,
      eventName,
      estartdt,
      eenddt,
      tzone
    ) {
      if (eventid != "") {
        if (typeof eventid !== "undefined") {
          store.commit("addEventID", eventid);
        }
      }

      if (eventCollectionname != "") {
        if (typeof eventCollectionname !== "undefined") {
          store.commit("addEventCollection", eventCollectionname);
        }
      }

      if (eventName != "") {
        if (eventName !== "undefined") {
          store.commit("addEventName", eventName);
        }
      }

      if (estartdt != "") {
        if (typeof estartdt !== "undefined") {
          store.commit("addEventSdate", estartdt);
        }
      }

      if (eenddt != "") {
        if (typeof eenddt !== "undefined") {
          store.commit("addEventEdate", eenddt);
        }
      }

      if (tzone != "") {
        if (typeof tzone !== "undefined") {
          store.commit("addZone", tzone);
        }
      }
    },
    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onExpoSelection() {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },

    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      eventsubscribe.SubscribeUser(
        obj.eventcollectionname,
        obj.user[0].Email,
        obj.user[0].id,
        obj.ShowNotification
      );
    },

    showLoader: function () {
      vm.loaderFlg = true;
    },

    hideLoader: function () {
      clearTimeout(this.timerLoader);
      vm.loaderFlg = false;
    },

    goForRegister: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientID = obj.client[0].id;
      console.log("Client ID>> " + ClientID);
      //--------------------OPENevents--------------------------------------------------------------------------
      var cnt = 0;
      db.collection("OA_UAT")
        .doc("ClientList")
        .collection("Clients")
        .doc(ClientID)
        .collection("Events")
        .where("EventTypeId", "==", 2)
        .where("AllowRegistration", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            cnt++;
            if (doc != undefined) {
              if (doc.data() != undefined) {
                vm.arrEvents.push(doc.data().EventId);
                vm.arrEvents.push(doc.data().EventFullName);
                console.log("vm.arrEvents 1 - " + vm.arrEvents);
              }
            }
          });

          if (cnt > 0) {
            if (vm.EnableSelfService) {
              if (cnt > 1) {
                router.push({
                  path: "/events",
                });
              } else {
                let str = vm.arrEvents[1].replace(/ /g, "_");
                let str2 = str.replace(/%20/g, " ");
                router.push({
                  path: "/eventv3/" + vm.arrEvents[0] + "/" + str2,
                });
              }
            } else {
              if (cnt > 1) {
                //console.log("vm.arrEvents2 - " + vm.arrEvents);
                let routeData = router.resolve({
                  path: "/events",
                });
                window.open(routeData.href, "_blank");
              } else {
                //console.log("vm.arrEvents[1]:- " + vm.arrEvents[1]);
                let str = vm.arrEvents[1].replace(/ /g, "_");
                let str2 = str.replace(/%20/g, " ");
                // console.log("str2:- " + str2);
                // console.log("vm.arrEvents[0]:- " + vm.arrEvents[0]);
                let routeData = router.resolve({
                  path: "/event/" + vm.arrEvents[0] + "/" + str2,
                });
                window.open(routeData.href, "_blank");
              }
            }
          } else {
            document.getElementById("dvOtherMsg").innerText =
              "Currently there are no events for you to register, please contact Event Organizer for assistance.";
            $("#Othermsg-modal").modal("show");
          }
        });
      //----------------------------------------------------------------------------------------------
    },
  },
  beforeDestroy() {
    hasMore = true;
    vm.EventsData = [];
    vm.searchtext = "";
  },
  async mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    this.localTimeZone = common.getTimeZoneName();
    this.$nextTick(() => {
      this.EnableSelfService = this.IsSelfServiceEnabled();
      if (this.$store.state.DefaultLoginLandingPage == "/clientLobby")
        this.$store.commit("setDefaultLoginLandingPage", "enableMainLobby");
    });
    this.mainLobbyLoader = false;
    console.log(`event list page mounted Success Execution time:`, new Date());
    //$("#leftmenu").hide();
    this.ShowRegisterEventButton = this.$t(
      "client.displayRegisterNewEventButtonAllEvent"
    );
    vm = this;
    vm.showLoader();
    store.commit("AddEventBannerRedirect", "");
    store.commit("Lobbyloaded", true);
    vm.getGeneralSettings();
    vm.refreshTokenBeforeEventCall();

    //  vm.hideLoader();
    // window.Tawk_API.onLoad = function () {
    //   window.Tawk_API.hideWidget();
    // };
    console.log(
      `event list page mounted end Success Execution time:`,
      new Date()
    );
  },
  computed: {
    BannerURL() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.branding[0].banner;
    },
    pageBg() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.EventBranding[0].bg2;
    },
    Userlists() {
      var firstName = "";
      var pPic = "";

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj != undefined && obj !== null) {
        if (obj.user != undefined && obj.user != null) {
          if (obj.user.length > 0) {
            if (obj.user[0].fname !== undefined) {
              firstName = obj.user[0].fname;
            }
            if (obj.user[0].profilepic !== undefined) {
              pPic = obj.user[0].profilepic;
            }
          }
        }
      }
      return {
        userName: firstName,
        userImage: pPic,
      };
    },
  },
};
</script>
